export const setEmptySpaceOnMobile = () => {
  const setEmptySpace = () => {
    if (window.innerWidth < 992) {
      const spaces: NodeListOf<HTMLElement> = document.querySelectorAll('.wp-block-spacer')

      if (spaces.length) {
        spaces.forEach(space => {
          const { clientHeight } = space

          if (clientHeight >= 100) space.style.height = '80px'
          if (clientHeight >= 50) space.style.height = '50px'
        })
      }
    }
  }

  setEmptySpace()
  window.addEventListener('resize', setEmptySpace)
}
